import React, { useState } from "react";
import { Menu, MenuItem, Button } from "@mui/material";

export interface DropdownItem {
  category_id: string;
  name: string;
  subcategories?: DropdownItem[];
}

const MultiLevelDropdown: React.FC<{
  data: DropdownItem[];
  setCategoryId?: React.Dispatch<React.SetStateAction<string>>;
}> = ({ data, setCategoryId }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [currentMenuData, setCurrentMenuData] = useState<DropdownItem[] | null>(
    null
  );
  const [childMenus, setChildMenus] = useState<
    { anchorEl: HTMLElement; data: DropdownItem[] }[]
  >([]);
  const [selectedItemId, setSelectedItemId] = useState<string | null>(null);
  // const [selectedItemName, setSelectedItemName] = useState<string | null>(null);

  const handleOpenMenu = (
    event: React.MouseEvent<HTMLElement>,
    items: DropdownItem[]
  ) => {
    setAnchorEl(event.currentTarget);
    setCurrentMenuData(items);
    setChildMenus([]); // Reset child menus when opening the main menu
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
    setCurrentMenuData(null);
    setChildMenus([]);
  };

  const handleOpenChildMenu = (
    event: React.MouseEvent<HTMLElement>,
    children: DropdownItem[]
  ) => {
    setChildMenus((prev) => [
      ...prev,
      { anchorEl: event.currentTarget, data: children },
    ]);
  };

  const handleCloseChildMenu = (index: number) => {
    setChildMenus((prev) => prev.slice(0, index));
  };

  const handleSelectItem = (id: string, category_id: string) => {
    setSelectedItemId(id);
    // setSelectedItemName(name)
    handleCloseMenu();
    if (setCategoryId) {
      setCategoryId(category_id);
    }
  };

  return (
    <div>
      <div className="multi-dropdown">
        <label>
          Select Parent Category:{" "}
          <span style={{ fontWeight: "bold" }}>
            {selectedItemId?.toUpperCase()}
          </span>{" "}
        </label>

        <div>
          <Button
            variant="contained"
            onClick={(e) => handleOpenMenu(e, data)}
            style={{ marginTop: "1rem", width: "500px" }}
          >
            Click to open the dropdown parent category
          </Button>
        </div>
      </div>
      {/* Parent Menu */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleCloseMenu}
        style={{ marginTop: "1rem" }}
      >
        {currentMenuData?.map((item) => (
          <MenuItem
            style={{ width: "300px" }}
            key={item.category_id}
            onClick={(e) => {
              item.subcategories && item.subcategories.length > 0
                ? handleOpenChildMenu(e, item.subcategories)
                : handleSelectItem(item.name, item.category_id);
            }}
          >
            {item.name}
          </MenuItem>
        ))}
      </Menu>

      {/* Child Menus */}
      {childMenus.map((childMenu, index) => (
        <Menu
          key={index}
          anchorEl={childMenu.anchorEl}
          open={Boolean(childMenu.anchorEl)}
          onClose={() => handleCloseChildMenu(index)}
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
        >
          {childMenu.data.map((childItem) => (
            <MenuItem
              style={{ width: "300px" }}
              key={childItem.category_id}
              onClick={(e) => {
                childItem.subcategories && childItem.subcategories.length > 0
                  ? handleOpenChildMenu(e, childItem.subcategories)
                  : handleSelectItem(childItem.name, childItem.category_id);
              }}
            >
              {childItem.name}
            </MenuItem>
          ))}
        </Menu>
      ))}
    </div>
  );
};

export default MultiLevelDropdown;
